import {
  UPDATE_STATION,
  UPDATE_TYPE,
  UPDATE_SKILLS,
  UPDATE_COND,
  UPDATE_INFO,
  CHANGE_MODIFY_MODE,
  CHANGE_VALID,
  REGISTER,
} from './actions';

const AppReducer = (state, action) => {
  switch(action.type){
    case UPDATE_STATION: {
      const { updStation } = action;
      const { ekiName, ekiCd, moveTypeCd, moveTime, moveTimeFromBusStop, lpMode, lpID, lpOrigin } = updStation;
      return { ...state, ekiName, ekiCd, moveTypeCd, moveTime, moveTimeFromBusStop, lpMode, lpID, lpOrigin };
    }
  
    case UPDATE_TYPE: {
      const { updType } = action;
      const { physicalCare, lifeSupport, otherWorkText } = updType;
      return { ...state, physicalCare, lifeSupport, otherWorkText };
    }
    case UPDATE_SKILLS: {
      const { updSkill } = action;
      const { experience, qualification, qualificationText, suggestHourSalary, hasQualificationText } = updSkill;
      return { ...state, experience, qualification, qualificationText, suggestHourSalary, hasQualificationText };
    }
    case UPDATE_COND: {
      const { updCond } = action;
      const { 
        fromDate,
        pendingFromDateFlag,
        toDate, 
        pendingToDateFlag,
        workStyle,
        workStyleKbn,
        dayOfTheWeek, 
        earlyShiftStartHour, // 早番
        earlyShiftStartMin,
        earlyShiftEndHour,
        earlyShiftEndMin,
        earlyShiftRestTime,
        dayShiftStartHour, // 日勤
        dayShiftStartMin,
        dayShiftEndHour,
        dayShiftEndMin,
        dayShiftRestTime,
        lateShiftStartHour, // 遅番
        lateShiftStartMin,
        lateShiftEndHour,
        lateShiftEndMin,
        lateShiftRestTime,
        nightShiftStartHour, // 夜勤
        nightShiftStartMin,
        nightShiftEndHour,
        nightShiftEndMin,
        nightShiftRestTime,
        fixedStartHour, // 固定勤務
        fixedStartMin,
        fixedEndHour,
        fixedEndMin,
        fixedRestTime,
        minBusinessDay,
        maxBusinessDay,
        canCommuteByCar,
        freeComment,
        hourSalary,
      } = updCond;

      return {
        ...state,
        fromDate,
        pendingFromDateFlag,
        toDate,
        pendingToDateFlag,
        workStyle,
        workStyleKbn,
        dayOfTheWeek, 
        earlyShiftStartHour, // 早番
        earlyShiftStartMin,
        earlyShiftEndHour,
        earlyShiftEndMin,
        earlyShiftRestTime,
        dayShiftStartHour, // 日勤
        dayShiftStartMin,
        dayShiftEndHour,
        dayShiftEndMin,
        dayShiftRestTime,
        lateShiftStartHour, // 遅番
        lateShiftStartMin,
        lateShiftEndHour,
        lateShiftEndMin,
        lateShiftRestTime,
        nightShiftStartHour, // 夜勤
        nightShiftStartMin,
        nightShiftEndHour,
        nightShiftEndMin,
        nightShiftRestTime,
        fixedStartHour, // 固定勤務
        fixedStartMin,
        fixedEndHour,
        fixedEndMin,
        fixedRestTime,
        minBusinessDay,
        maxBusinessDay,
        canCommuteByCar,
        freeComment,
        hourSalary,
      };   
    }
    case UPDATE_INFO: {
      const { updInfo } = action;
      const {
        corpName,
        facilityName,
        facilityType,
        capacity,
        userName,
        tel,
        email,
        emailConf,
        zip,
        municipality,
        houseNumber,
      } = updInfo;

      return {
        ...state,
        corpName,
        facilityName,
        facilityType,
        capacity,
        userName,
        tel,
        email,
        emailConf,
        zip,
        municipality,
        houseNumber,
      };
    }
    case CHANGE_MODIFY_MODE: {
      const { isModify } = action;
      return { ...state, isModify };
    }
    case CHANGE_VALID: {
      const { path, valid } = action;
      const { validMap } = state;
      return { ...state, validMap: { ...validMap, [path]: valid } };
    }
    case REGISTER: {
      return { ...state, isRegistered: true };
    }
    default: {
      return state;
    }
  }
};

export default AppReducer;
